// extracted by mini-css-extract-plugin
export default {"tabContent":"KWw8TuNSBT"};